import React from 'react';
import { ViewportProvider } from '@/context/viewport.context';

const withViewport = (props) => {
  return <ViewportProvider>{props.children}</ViewportProvider>;
};

export default withViewport;
